import Api from '@/api/api.js'

export default {
    //Liste des patients
    patients() {
        const promise = Api().get('/patients/tous-patients/liste')
        return promise.then((response) => response.data)
    },

    getPatient(id) {
        const promise = Api().get('/patients/' + id)
        return promise.then((response) => response.data)
    },

    savePatient(data) {
        const promise = Api().post('/patients/save', data)
        return promise.then((response) => response.data)
    },

    deletePatient(id) {
        const promise = Api().delete('/patients/delete/' + id)
        return promise.then((response) => response.data)
    },

    searchPatient(data) {
        const promise = Api().post('/patients/search', data)
        return promise.then((response) => response.data)
    },

    getHistorique(id) {
        const promise = Api().get('/patients/historique/' + id)
        return promise.then((response) => response.data)
    },

    historiqueDatePatient(id, data) {
        const promise = Api().get('/patients/historique_by_date/' + id, data)
        return promise.then((response) => response.data)
    },

    getInfoPatient(patient_id) {
        const promise = Api().get('/patients/'+patient_id+'/info')
        return promise.then((response) => response.data)
    },

    getInfoAssurePrincipal(patient_id) {
        const promise = Api().get('/patients/'+patient_id+'/assure_principal')
        return promise.then((response) => response.data)
    },

    getInfoPersonneAPrevenir(patient_id) {
        const promise = Api().get('/patients/'+patient_id+'/info_personne_a_prevenir')
        return promise.then((response) => response.data)
    },

    getListeTousPatients(data) {
        const promise = Api().post('/patients/get-patients', data)
        return promise.then((response) => response.data)
    },

    getInfoAssurancePatient(patient_id) {
        const promise = Api().get('/patients/'+patient_id+'/insurance-info')
        return promise.then((response) => response.data)
    },
}